import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "faq"
    }}>{`FAQ`}</h1>
    <h2 {...{
      "id": "what-is-rnb-seasonal-pricing"
    }}>{`What is RnB Seasonal Pricing?`}</h2>
    <p>{`Answer: Seasonal Pricing is an extension for RnB -WooCommerce plugin. It helps you to charge promotional/seasonal pricing for specific date range of any rental product.`}</p>
    <h2 {...{
      "id": "what-functionalities-does-seasonal-pricing-provide"
    }}>{`What Functionalities does Seasonal Pricing Provide?`}</h2>
    <p>{`Answer: Seasonal Pricing Helps to create multple date range for RnB inventory.`}</p>
    <p><img alt="Seasonal date range" src={require("./images/date-range.png")} /></p>
    <h2 {...{
      "id": "what-is-the-requirement-for-seasonal-pricing-to-function-properly"
    }}>{`What is the requirement for Seasonal Pricing to function properly?`}</h2>
    <p>{`Answer: You must have RnB- WooCommerce plugin installed. Seasonal Pricing work as an RnB extension in order to work you will be RnB WooCommerce plugin.`}</p>
    <h2 {...{
      "id": "how-to-setup-seasonal-pricing-fields"
    }}>{`How to setup Seasonal Pricing Fields?`}</h2>
    <p><inlineCode parentName="p">{`Inventory -> Seasonal Pricing -> Add Seasons`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      